export enum PrequoteProgressEnum {
	CreatingNewQuote = 1,
	SelectingSuppliers = 2,
	Finished = 3,
	Error = 5,
}
